module.exports = __webpack_public_path__ + "img/loading-gate.0bb591c8.gif";